/*
* Storytelling
*/
export default

window.Carousel_Storytelling = function() {
  return {
    rewind: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
      }
    },
  }
}
